const EstimatedPriceModal = ({ estimateInfo, setEstimateInfo }) => {

  const handleClose = () => {
    setEstimateInfo({ ...estimateInfo, success: false });
  };

  return (
    <div className="modal">
      <div className="modal__content">
        <img
          src="/img/delete.png"
          alt=""
          className="modal__img"
          onClick={handleClose}
        />
        <p className="modal__price">
          هزینه ارسال بسته شما با این مشخصات
        </p>
        <span>
          <strong>{estimateInfo.price}</strong> تومان{" "}
        </span>
        <button
          className="btn btn--secondary btn--secondary-modal"
          style={{ marginTop: '1rem' }}
          onClick={handleClose}
        >
          تایید
        </button>
      </div>
    </div>
  );
};

export default EstimatedPriceModal;
